import React, { useMemo } from 'react';
import HeaderNavItem from './HeaderNavItem';
import { useNavItems } from './navItems';
import type { NavItem } from './types';
import { isNavItemActive } from './utils';

const isItemShown = (item: NavItem) => !('shown' in item) || item.shown !== false;

const useMainDesktopNavItems = (): NavItem[] => {
  const navItems = useNavItems();

  return useMemo(() => {
    return [
      {
        name: 'Tax',
        children: [
          navItems.taxDashboard,
          navItems.holdings,
          navItems.taxGuide,
          navItems.incomeDashboard,
        ].filter(isItemShown),
      },
      navItems.documents,
      navItems.allTransactions,
      navItems.imports,
      navItems.profile,
      navItems.recon,
    ].filter(isItemShown);
  }, [navItems]);
};

const useAdminPageNavItems = (): NavItem[] => {
  const navItems = useNavItems();

  return useMemo(
    () => [navItems.admin, navItems.csvsInReview, navItems.apiErrors, navItems.scripts, navItems.trello],
    [navItems],
  );
};

type Props = {
  isAdminPage: boolean;
};

export default function DesktopNavItems({ isAdminPage }: Props) {
  const mainDesktopNavItems = useMainDesktopNavItems();
  const adminPageNavItems = useAdminPageNavItems();

  if (isAdminPage) {
    return (
      <>
        {adminPageNavItems.map((item) => {
          return (
            <HeaderNavItem key={item.name} item={item} active={isNavItemActive(item, location.pathname)} />
          );
        })}
      </>
    );
  }
  return (
    <>
      {mainDesktopNavItems.map((item) => {
        return (
          <HeaderNavItem key={item.name} item={item} active={isNavItemActive(item, location.pathname)} />
        );
      })}
    </>
  );
}
